/** @jsx isolateComponent */
import { ServiceIcons } from '@zapier/design-system';
import { DEFAULT_SERVICE_ICON_URL_GREY } from '@zapier/product-get-help/src';
import { isolateComponent } from '@zapier/style-encapsulation';

import { ZapType } from '../useData';

type ZapIconsProps = {
  /** Nodes to display icons for. */
  nodes: ZapType['nodes'];
};

const ZapIcons = ({ nodes }: ZapIconsProps) => {
  const servicesMap = nodes.map(node => ({
    name: node.selectedApi || 'App',
    src: node.appImage64 || DEFAULT_SERVICE_ICON_URL_GREY,
  }));
  return <ServiceIcons maxServices={3} services={servicesMap} size={30} />;
};

export default ZapIcons;
